import store from 'vuex-store/index'
import router from '@/router'
import { showNotice } from '@/utils/tool'
import i18n from '@/i18n'
import Vue from 'vue'

export function login(data, redirectPath) {
  store.dispatch('SetUserData', data)
  store.dispatch('UpdateCsUrl')
  // socket重連
  Vue.prototype.$socket.reinit()

  if (redirectPath == null) {
    return
  }

  if (redirectPath.indexOf('match') > -1) {
    window.location.href = redirectPath
    return
  }

  if (data.member_info.password_valid === 0) {
    // 強制改密碼
    showNotice(i18n.t('Bao.reset_password_notice'))
    router.push({ path: '/user/reset' })
  } else {
    // 登入
    if (redirectPath === undefined) {
      redirectPath = 'index'
    }
    router.push({ path: '/' + redirectPath }).catch(() => {
    })
  }

  if (data.member_info) {
    store.commit('SET_GOLD_INFO', data.gold_info)
    store.commit('SET_GOLD_TOTAL', data)
    store.commit('SET_MAIN_GOLD', data)
    store.commit('SET_BONUS_GOLD', data)
    store.commit('SET_MAIN_POINT', data)
    store.commit('SET_MAIN_TURNOVER', data)
    store.commit('SET_COMMISSION_GOLD', data)
  }

  if (data.member_info.main_points !== undefined && data.member_info.bonus_points !== undefined) {
    store.commit('SET_POINTS', data.member_info)
  }
}

export function logout(msg) {
  // 呼叫app
  try {
    window.webkit.messageHandlers.openLogin.postMessage(null)
    return
  } catch (e) {
    // console.error(e)
  }
  try {
    window.JSInterface.openLogin()
    return
  } catch (e) {
    // console.log(e)
  }

  router.push({ path: '/' }).catch(() => {
  })
  if (msg === undefined) {
    msg = i18n.t('Bao.has_logout')
  }
  store.dispatch('LogOut').then(() => {
    store.dispatch('UpdateCsUrl')
    const iframeBottom = document.querySelector('.iframe-overlay')
    try {
      // eslint-disable-next-line
      if (WebviewInterface !== undefined) {
        // eslint-disable-next-line
        WebviewInterface.logout()
      }
    } catch (e) {
      console.log('WebviewInterface', e)
      store.commit('SET_GAME_URL', '')
      if (iframeBottom) {
        iframeBottom.style.display = 'none'
      }
    }
    // socket斷線
    Vue.prototype.$socket.close()
    showNotice(msg)
  })
}
